module.exports = __webpack_public_path__ + "img/logo.8416a0bd.png";